import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';

import { REPORT_REASONS, reportPost } from '../utils/reportPost.mjs';

export default class ReportPostModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.reason = Stream('');
    this.description = Stream('');
    this.success = false;
  }

  className() {
    return 'YingtaoReportModal Modal--medium';
  }

  title() {
    return app.translator.trans('yingtao-forum-homepage.forum.report.title');
  }

  content() {
    if (this.success) {
      return (
        <div className="Modal-body">
          <div className="Form Form--centered">
            <p className="helpText">{app.translator.trans('yingtao-forum-homepage.forum.report.success')}</p>
            <Button className="Button Button--primary Button--block" onclick={() => this.hide()}>
              {app.translator.trans('yingtao-forum-homepage.forum.report.close')}
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group YingtaoReportModal-reasons">
            {REPORT_REASONS.map((reason) => (
              <label className="YingtaoReportModal-reason" key={reason}>
                <input
                  type="radio"
                  name="yingtao-report-reason"
                  value={reason}
                  checked={this.reason() === reason}
                  onchange={withAttr('value', this.reason)}
                />
                <span>{app.translator.trans(`yingtao-forum-homepage.forum.report.reason_${reason}`)}</span>
              </label>
            ))}
          </div>
          <div className="Form-group">
            <label>
              {app.translator.trans('yingtao-forum-homepage.forum.report.description_label')}
              <textarea
                className="FormControl"
                maxlength="2000"
                rows="4"
                value={this.description()}
                oninput={withAttr('value', this.description)}
                placeholder={app.translator.trans('yingtao-forum-homepage.forum.report.description_placeholder')}
              />
            </label>
          </div>
          <div className="Form-group">
            <Button
              className="Button Button--primary Button--block YingtaoReportModal-submit"
              type="submit"
              loading={this.loading}
              disabled={!this.reason()}
            >
              {app.translator.trans('yingtao-forum-homepage.forum.report.submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();

    if (!this.reason()) return;

    this.loading = true;

    reportPost(app, this.attrs.post.id(), this.reason(), this.description())
      .then(() => {
        this.attrs.post.pushAttributes({
          canYingtaoReport: false,
          hasYingtaoReported: true,
        });
        this.success = true;
      })
      .catch(this.onerror.bind(this))
      .then(this.loaded.bind(this));
  }
}
